<template>
  <DialogTemplateToolkit
    class-name="create-release-dialog"
    :data-qa="'create-release-dialog'"
    :dialog.sync="dialog"
    :first_btn="!!release ? 'Common.Edit' : 'Common.Add'"
    :loading="loading"
    :title="$t('Releases.SpecifyParameters')"
    width="600"
    @apply="apply"
    @close="close">
    <template #activator-btn>
      <sButton
        v-if="btn"
        icon="plus"
        icon-size="12px"
        type="border"
        @click="open">
        {{ $t('Releases.AddNewRelease') }}
      </sButton>
      <MenuItem
        v-else-if="!!release"
        data-qa="edit-release"
        icon="edit"
        :label="$t('Releases.EditRelease')"
        @click="open"/>
      <MenuItem
        v-else
        data-qa="add-newrelease"
        icon="plus"
        :label="$t('Releases.AddNewRelease')"
        @click="open"/>
    </template>
    <template #card-text>
      <sForm
        ref="createReleaseForm"
        :disabled="loading"
        label-position="top"
        :model="model"
        :rules="rules">
        <sFormItem
          :label="$t('Tenders.Nomination')"
          prop="publishName">
          <sInput
            clearable
            data-qa="create-additional-field__name"
            :max-length="4000"
            max-rows="5"
            :placeholder="$t('Tenders.Nomination')"
            rows="1"
            type="textarea"
            :value.sync="model.publishName"/>
        </sFormItem>
        <sFormItem
          :label="$t('Common.Date')"
          prop="date">
          <DateMenu
            ref="menu_date_end"
            :disabled="loading"
            :min_date="min_date"
            :value.sync="dateString"
            with_allowed_dates/>
        </sFormItem>
      </sForm>
    </template>
  </DialogTemplateToolkit>
</template>
<script>
import MenuItem from 'components/common/MenuItem.vue'
import DateMenu from 'components/common/inputs/DateMenu.vue'
import DialogTemplateToolkit from 'components/common/dialogs/DialogTemplateToolkit.vue'

import moment from 'moment'

export default {
  name: 'createRelease',
  data() {
    const that = this
    return {
      dialog: false,
      model: {
        id: '',
        date: '',
        gitName: '',
        publishName: '',
        isPublished: false,
      },
      rules: {
        publishName: [
          {
            type: 'string',
            trigger: 'change',
            required: true,
            message: that.$t('Validate.Required')
          },
          {
            type: 'string',
            required: true,
            trigger: 'exit',
            max: 245,
            message: that.$t('Validate.maxLength', {number: 245, type: that.$tc('Common.characters', 10) })
          }
        ],
        date: [
          {
            type: 'string',
            trigger: 'change',
            required: true,
            message: that.$t('Validate.Required')
          }
        ],
        gitName: [],
        isPublished: [],
      },
      loading: false
    }
  },
  props: {
    btn: Boolean,
    release: Object,
  },
  created() {
    this.model.date = moment().format('DD.MM.YYYY')
  },
  computed: {
    dateString: {
      get() {
        if (!this.model.date) {
          return null
        }
        const d = this.model.date.slice(0,2)
        const m = this.model.date.slice(3,5)
        const y = this.model.date.slice(6,10)
        return `${y}.${m}.${d}`
      },
      set(newValue) {
        this.model.date = this.$d(new Date(newValue))

      }
    },
    min_date() {
      return moment().format('YYYY-MM-DD')
    },
    date_format: {
      get() {
        if (!parseFloat(this.model.date)) {
          return null
        }
        if (!moment(this.model.date, 'DD.MM.YYYY').isValid() && moment(this.model.date).isValid() ) {
          const newDate = moment(this.model.date).format('DD.MM.YYYY')
          if (newDate !== this.model.date) {
            this.$set(this.model, 'date', moment(this.model.date).format('DD.MM.YYYY'))
          }
          // this.model.date = moment(this.model.date).format('DD.MM.YYYY')
        }
        return moment(this.model.date, 'DD.MM.YYYY').format('YYYY-MM-DD')
      },
      set(newValue) {
        this.model.date = moment(newValue, 'YYYY-MM-DD').format('DD.MM.YYYY')
      }
    },
  },
  methods: {
    open() {
      this.dialog = true
      if (this.release) {
        const release = this.$_.cloneDeep(this.release)
        release.date = this.$d(new Date(release.dateTime))
        this.$set(this, 'model', release)
        this.$nextTick(() => {
          this.$refs.createReleaseForm.validate()
        })
      }
    },
    close() {
      this.dialog = false
    },
    apply() {
      this.$refs.createReleaseForm.validate().then((valid) => {
        if (!valid) { return }

        this.loading = true
        this.$store.dispatch(this.model.id ? 'changeRelease' : 'createRelease', {
          id: this.model.id || 0,
          gitName: this.model.gitName,
          publishName: this.model.publishName,
          dateTime: this.date_format,
          isPublished: false,
        })
          .then(res => {
            if (!this.model.id && !res) {
              this.$notice.error({
                title: this.$t('Common.ErrorTitle'),
                duration: 10,
              })
              return
            }
            if (!this.model.id ) {
              this.$emit('choeseRelease', res )
            }

            this.close()
            this.model.id  = ''
            this.model.gitName = ''
            this.model.publishName = ''
          })
          .finally(() => {
            this.loading = false
          })
      })
    }
  },
  components: {
    MenuItem,
    DateMenu,
    DialogTemplateToolkit
  }
}
</script>
<style lang="scss" scoped>
.name-input {
  width: 400px;
}
.data-field {
  width: 200px;
}
</style>
